<mat-form-field>
  <mat-select [formControl]="timeZoneCtrl" [placeholder]="'timeZone' | translate" #singleSelect>
    <mat-option>
      <ngx-mat-select-search [formControl]="timeZoneFilterCtrl"
                       [placeholderLabel]="'search_timeZone' | translate" 
                       [noEntriesFoundLabel]="'no_matching_timeZone' | translate">
          <mat-icon class="clear-search-icon" ngxMatSelectSearchClear fontSet="fa" fontIcon="fa-times"></mat-icon>
      </ngx-mat-select-search>
    </mat-option>
    @for (timezone of filteredTimezones$ | async; track timezone) {
      <mat-option [value]="timezone">{{timezone.value}}</mat-option>
    }
  </mat-select>
</mat-form-field>